export const quickStatsConstants = {
  FETCH_ENROLLED_COURSES_SUCCESS: 'FETCH_ENROLLED_COURSES_QUICK_STATS_SUCCESS',
  FETCH_MAUS_SUCCESS: 'FETCH_MAUS_QUICK_STATS_SUCCESS',
  FETCH_COURSE_COMPLETIONS_SUCCESS: 'FETCH_COURSE_COMPLETIONS_QUICK_STATS_SUCCESS'
};
